import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import { useSelector } from "react-redux";
import MerchantTopupTable from "./MerchantTopupTable";
import { FiRefreshCcw } from "react-icons/fi";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const MerchantTopupPendingTable = () => {

    const { callApi: fetchPendingRequest } = useApi("/admin/cashin/pending", "GET");
    const { callApi: approveRequest } = useApi("/admin/cashin/approve", "POST");
    const { callApi: rejectRequest } = useApi("/admin/cashin/reject", "POST");
    const { callApi: fetchPendingRequestBank } = useApi("/admin/cashin/pending/byBank", "GET");
    const { callApi: fetchBankCount } = useApi("/admin/cashin/pending/bank-count", "GET");
    const { callApi: walletbalance } = useApi("/admin/cashin/wallet/balance", "GET");
    const { callApi: checksrijipayBalance } = useApi(
        "/admin/users/srijipay/check-balance",
        "POST"
    );

const [soliteckBalance, setSoliteckBalance] = useState("");
const [soliteckBalanceLoading, setSoliteckBalanceLoading] = useState(false);

const { callApi: checkSoliteckBalance } = useApi(
    "/admin/users/soliteck/check-balance",
    "POST"
);

const fetchSoliteckBalance = async () => {
    setSoliteckBalanceLoading(true);

    try {
        const res = await checkSoliteckBalance();

        // Since your response is: {"status":true,"message":"Balance Fetch","balance":"3177758.7900"}
        if (res?.status === true) {
            setSoliteckBalance(res.balance);
        }
    } catch (err) {
        console.error("Soliteck Balance fetch failed", err);
    } finally {
        setSoliteckBalanceLoading(false);
    }
};

    const { callApi: checktramoBalance } = useApi(
        "/admin/users/tramo/check-balance",
        "GET"
    );

    const [finzepBalance, setFinzepBalance] = useState("");
    const [finzepBalanceLoading, setFinzepBalanceLoading] = useState(false);

    const { callApi: checkfinzepBalance } = useApi(
        "/admin/users/finzep/check-balance",
        "GET"
    );

    const [finkedaBalance, setFinkedaBalance] = useState("");
    const [finkedaBalanceLoading, setFinkedaBalanceLoading] = useState(false);

    const { callApi: checkFinkedaBalance } = useApi("/pg/finkeda/balance", "GET");
    // const fetchfinzepBalance = async () => {
    //     setFinzepBalanceLoading(true);

    //     try {
    //         const res = await checkfinzepBalance();

    //         // 👇 IMPORTANT: Adjust "res?.data?.balance" to match the actual key returned by your Finzep API!
    //         // E.g., it might be res.balance, res.RunningBalance, or res.data.available
    //         if (res) { 
    //             setFinzepBalance(res?.data?.balance || res?.balance || 0);
    //         }

    //     } catch (err) {
    //         console.error("Finzep Balance fetch failed", err);
    //     } finally {
    //         setFinzepBalanceLoading(false);
    //     }
    // };
const fetchfinzepBalance = async () => {
        setFinzepBalanceLoading(true);

        try {
            const res = await checkfinzepBalance();

            // Check if status is 2 (or errorcode is "200") and grab the "bal" value
            if (res?.status === 2 || res?.errorcode === "200") {
                setFinzepBalance(res.bal);
            }

        } catch (err) {
            console.error("Finzep Balance fetch failed", err);
        } finally {
            setFinzepBalanceLoading(false);
        }
    };

    const fetchFinkedaBalance = async () => {
        setFinkedaBalanceLoading(true);
        try {
            const res = await checkFinkedaBalance();
            if (res?.operativeBalance !== undefined && res?.operativeBalance !== null) {
                setFinkedaBalance(Number(res.operativeBalance).toFixed(2));
            }
        } catch (err) {
            console.error("Finkeda Balance fetch failed", err);
        } finally {
            setFinkedaBalanceLoading(false);
        }
    };

    const userId = useSelector((state) => state.auth.employeeDetails.userId);
    const username = useSelector((state) => state.auth.employeeDetails.username);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [walletBalance, setWalletBalance] = useState(0);
    const [proofPopup, setProofPopup] = useState({
        open: false,
        url: ""
    });

    const [amountInput, setAmountInput] = useState({});
    const [remarks, setRemarks] = useState({});

    const [loadingAction, setLoadingAction] = useState(false);
    const [bankCount, setBankCount] = useState([]);
    const [refreshing, setRefreshing] = useState(false);
    const [tpEnabled, setTpEnabled] = useState(false);

    const [message, setMessage] = useState({
        text: "",
        type: ""
    });

    const [confirmPopup, setConfirmPopup] = useState({
        open: false,
        type: "",
        row: null,
        index: null
    });

    const [otpPopup, setOtpPopup] = useState({ open: false, pendingPayload: null, sentTo: [] });
    const [otpInput, setOtpInput] = useState("");
    const [otpError, setOtpError] = useState("");
    const [otpLoading, setOtpLoading] = useState(false);
    const [mpin, setMpin] = useState("");

    /* ----------- ADDED STATE FOR BANK FILTER ----------- */

    const [selectedBank, setSelectedBank] = useState("");
    const [rotation, setRotation] = useState(0);

    const adminId = userId;

    const refreshAllData = async () => {
        try {
            setRefreshing(true);

            await Promise.all([
                fetchRequests(),
                fetchBankCounts(),
                fetchWalletBalance()
            ]);

            setRemarks({});
        } catch (err) {
            console.error(err);
        } finally {
            setRefreshing(false);
        }
    };






    /* ---------------- NEW STATE ---------------- */

    const [showThresholdEditor, setShowThresholdEditor] = useState(false);

    const [thresholds, setThresholds] = useState(() => {
        const saved = localStorage.getItem("balance_thresholds");

        return saved
            ? JSON.parse(saved)
            : {
                aeron: "",
                // nifi: "",
                dillipay: "",
                earthpay: "",
                indicore: "",
                instantpay: "",
                wallet: "",
                srijipay: "",
                tramo: "",
                finzep: "",
                finkeda: "",
                soliteck:""
            };
    });

    /* ---------------- SAVE TO LOCAL STORAGE ---------------- */

    useEffect(() => {
        localStorage.setItem(
            "balance_thresholds",
            JSON.stringify(thresholds)
        );
    }, [thresholds]);

    /* ---------------- HELPER ---------------- */

    const isBelowThreshold = (balance, threshold) => {
        if (!threshold) return false;

        return Number(balance || 0) < Number(threshold);
    };






    const fetchBankCounts = async () => {

        try {

            const res = await fetchBankCount();

            console.log("Bank Count API Response:", res);

            if (Array.isArray(res)) {

                const formatted = {};

                res.forEach((bank) => {

                    const key = bank.bankName;

                    if (formatted[key]) {

                        formatted[key].pendingCount += bank.pendingCount;

                    } else {

                        formatted[key] = {
                            bankName: bank.bankName,
                            nickName: bank.nickName,
                            pendingCount: bank.pendingCount
                        };

                    }

                });

                setBankCount(Object.values(formatted));

            }

        } catch (error) {

            console.error("Bank Count Error:", error);

        }

    };

    const fetchWalletBalance = async () => {

        try {

            const res = await walletbalance(null, `?userName=${username}`);

            console.log("Wallet Balance:", res);

            if (res?.balance !== undefined) {
                setWalletBalance(res.balance);
            }

        } catch (error) {

            console.error("Wallet Balance Error:", error);

        }

    };

    /* DATE FORMAT */

    const formatDateTime = (dateString) => {

        if (!dateString) return "-";

        const date = new Date(dateString.replace(" ", "T"));

        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        });
    };

    /* NUMBER TO WORDS */

    const numberToWords = (num) => {

        const a = ["", "One ", "Two ", "Three ", "Four ", "Five ", "Six ", "Seven ", "Eight ", "Nine ",
            "Ten ", "Eleven ", "Twelve ", "Thirteen ", "Fourteen ", "Fifteen ", "Sixteen ",
            "Seventeen ", "Eighteen ", "Nineteen "];

        const b = ["", "", "Twenty ", "Thirty ", "Forty ", "Fifty ",
            "Sixty ", "Seventy ", "Eighty ", "Ninety "];

        const inWords = (n) => {

            if (n < 20) return a[n];

            if (n < 100)
                return b[Math.floor(n / 10)] + a[n % 10];

            if (n < 1000)
                return a[Math.floor(n / 100)] + "Hundred " + inWords(n % 100);

            if (n < 100000)
                return inWords(Math.floor(n / 1000)) + "Thousand " + inWords(n % 1000);

            if (n < 10000000)
                return inWords(Math.floor(n / 100000)) + "Lakh " + inWords(n % 100000);

            return inWords(Math.floor(n / 10000000)) + "Crore " + inWords(n % 10000000);
        };

        return inWords(num) + "Only";
    };

    /* AMOUNT COLOR */

    const getAmountColor = (amount) => {

        if (amount >= 1000000) return "text-purple-700";
        if (amount >= 400000) return "text-red-600";
        return "text-black";
    };

    const getModeColor = (mode) => {

        if (mode === "Cash") return "text-green-600 font-semibold";
        if (mode === "CDM") return "text-blue-600 font-semibold";
        if (mode === "Online") return "text-indigo-600 font-semibold";

        return "";
    };

    /* FETCH API */

    const fetchRequests = async () => {

        try {

            setLoading(true);

            let res;

            if (selectedBank) {

                /* ----------- BANK API CALL ----------- */

                res = await fetchPendingRequestBank(null, `?bank_name=${selectedBank}`);

            } else {

                /* ----------- DEFAULT API ----------- */

                res = await fetchPendingRequest();

            }

            // if (Array.isArray(res)) {

            //     setData(res);
            //     // setData([...res].reverse());

            //     const defaultAmounts = {};

            //     res.forEach((r, index) => {
            //         defaultAmounts[index] = r.amount;
            //     });

            //     setAmountInput(defaultAmounts);
            // }

            if (Array.isArray(res)) {

                const reversed = [...res].reverse();
                setData(reversed);

                const defaultAmounts = {};

                reversed.forEach((item, index) => {
                    defaultAmounts[index] = item.amount;
                });

                setAmountInput(defaultAmounts);
            }
        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);
        }
    };


    const refreshAllBalances = async () => {
        await Promise.all([
            fetchBalance(),
            // fetchnifiBalance(),
            fetchdillipayBalance(),
            fetchearthypayBalance(),
            fetchindicoreBalance(),
            fetchinstantpayBalance(),
            fetchsrijipayBalance(),
            fetchtramoBalance(),
            fetchfinzepBalance(),
            fetchFinkedaBalance(),
            fetchSoliteckBalance()
        ]);
    };

    //     useEffect(() => {
    //         fetchRequests();
    //         fetchBankCounts();
    //         fetchWalletBalance();

    //         refreshAllBalances();

    // //         fetchBalance();
    // //             fetchnifiBalance();
    // //             fetchdillipayBalance();
    // //             fetchearthypayBalance();
    // //             fetchindicoreBalance();
    // //                 fetchinstantpayBalance();
    // //         fetchsrijipayBalance();
    // // fetchtramoBalance();
    //     }, [selectedBank]);

    /* FETCH REQUESTS WHEN BANK CHANGES */
    useEffect(() => {
        fetchRequests();
        fetchBankCounts();
    }, [selectedBank]);

    /* FETCH BALANCES ONLY ON INITIAL LOAD */
    useEffect(() => {
        fetchWalletBalance();
        refreshAllBalances();
    }, []);

    // useEffect(() => {

    //     const interval = setInterval(() => {
    //         refreshAllBalances();
    //     }, 30000);

    //     return () => clearInterval(interval);

    // }, []);

    useEffect(() => {
    const interval = setInterval(() => {
        refreshAllBalances();
    }, 15 * 60 * 1000); // 15 minutes = 900,000 ms

    return () => clearInterval(interval);
}, []);

    /* CONFIRM API */
    const handleConfirm = async () => {

        const { row, index, type } = confirmPopup;
        let approvePayload = null;

        try {
            setLoadingAction(true);

            let res;

            if (type === "approve") {

                approvePayload = {
                    requestId: row.requestId,
                    amount: amountInput[index],
                    adminId,
                    remarks: remarks[index],
                    tp: tpEnabled,
                    mpin,
                    mid: username
                };

                res = await approveRequest(approvePayload);

                setMessage({
                    text: res?.message || "Request Approved Successfully",
                    type: "success"
                });

            } else {

                const payload = {
                    requestId: row.requestId,
                    adminId,
                    remarks: remarks[index]
                };

                res = await rejectRequest(payload);

                setMessage({
                    text: res?.message || "Request Rejected Successfully",
                    type: "error"
                });
            }

            fetchRequests();
            await refreshAllData();

            setTimeout(() => {
                setTpEnabled(false);

                setConfirmPopup({
                    open: false,
                    type: "",
                    row: null,
                    index: null
                });

                setMessage({
                    text: "",
                    type: ""
                });

            }, 1500);

        } catch (error) {

            if (type === "approve" && approvePayload) {
                const errData = error?.responseData || {};
                if (errData?.error_code === "OTP_REQUIRED" && errData?.action_params?.otpRequired === true) {
                    setOtpPopup({
                        open: true,
                        pendingPayload: approvePayload,
                        sentTo: errData.action_params?.sentTo || []
                    });
                    return;
                }
            }

            setMessage({
                text: error?.message || "Something went wrong",
                type: "error"
            });

            setTimeout(() => {
                setConfirmPopup({
                    open: false,
                    type: "",
                    row: null,
                    index: null
                });

                setMessage({
                    text: "",
                    type: ""
                });
            }, 1000);

        } finally {
            setLoadingAction(false);
        }
    };

    const handleOtpSubmit = async () => {
        if (otpInput.length !== 6) {
            setOtpError("Please enter a valid 6-digit OTP");
            return;
        }

        setOtpLoading(true);
        setOtpError("");

        try {
            const payload = { ...otpPopup.pendingPayload, otp: otpInput.trim() };
            const res = await approveRequest(payload);

            setOtpPopup({ open: false, pendingPayload: null, sentTo: [] });
            setOtpInput("");

            setMessage({
                text: res?.message || "Request Approved Successfully",
                type: "success"
            });

            fetchRequests();
            await refreshAllData();

            setTimeout(() => {
                setTpEnabled(false);
                setConfirmPopup({ open: false, type: "", row: null, index: null });
                setMessage({ text: "", type: "" });
            }, 1500);

        } catch (error) {
            setOtpError(error?.message || "Invalid or expired OTP. Please try again.");
        } finally {
            setOtpLoading(false);
        }
    };


    const [balance, setBalance] = useState("");
    // const [balance, setBalance] = useState("");
    const [balanceLoading, setBalanceLoading] = useState(false);

    // const [nifiBalance, setnifiBalance] = useState("");
    // const [nifiBalanceLoading, setnifiBalanceLoading] = useState(false);

    const [dillipayBalance, setdillipayBalance] = useState("");
    const [dillipayBalanceLoading, setdillipayBalanceLoading] = useState(false);

    const [earthypayBalance, setearthypayBalance] = useState("");
    const [earthypayBalanceLoading, setearthypayBalanceLoading] = useState(false);

    const [indicoreBalance, setindicoreBalance] = useState("");
    const [indicoreBalanceLoading, setindicoreBalanceLoading] = useState(false);

    const [instantpayBalance, setinstantpayBalance] = useState("");
    const [instantpayBalanceLoading, setinstantpayBalanceLoading] = useState(false);

    const [enkashBalance, setenkashBalance] = useState("");
    const [enkashBalanceLoading, setenkashBalanceLoading] = useState(false);

    const [srijipayBalance, setsrijipayBalance] = useState("");
    const [srijipayBalanceLoading, setsrijipayBalanceLoading] = useState(false);

    const [tramoBalance, settramoBalance] = useState("");
    const [tramoBalanceLoading, settramoBalanceLoading] = useState(false);


    const { callApi: checkBalanceApi } = useApi(
        "/admin/users/aereon/check-balance",
        "POST"
    );

    // const { callApi: checkNifiBalance } = useApi(
    //     "/admin/users/nifi/check-balance",
    //     "POST"
    // );
    const { callApi: checkdillipayBalance } = useApi(
        "/admin/users/dillipay/check-balance",
        "POST"
    );
    const { callApi: checkearthypayBalance } = useApi(
        "/admin/users/earthpay/check-balance",
        "POST"
    );
    const { callApi: checkindicoreBalance } = useApi(
        "/admin/users/indicore/check-balance",
        "POST"
    );
    const { callApi: checkinstantpayBalance } = useApi(
        "/admin/users/instantpay/check-balance?latitude=20.1236&longitude=78.3228",
        "POST"
    );
    const { callApi: checkenkashBalance } = useApi(
        "/admin/users/enkash/check-balance",
        "POST"
    );


    const fetchBalance = async () => {
        setBalanceLoading(true);

        try {
            const res = await checkBalanceApi();

            if (res?.status === "SUCCESS") {
                setBalance(res.available_balance);
            }
        } catch (err) {
            console.error("Balance fetch failed");
        } finally {
            setBalanceLoading(false);
        }
    };

    // const fetchnifiBalance = async () => {
    //     setnifiBalanceLoading(true);

    //     try {
    //         const res = await checkNifiBalance();
    //         // const res = await checkBalanceApi();

    //         if (res?.status === "success") {
    //             setnifiBalance(res.data.balance);
    //         }
    //     } catch (err) {
    //         console.error("Balance fetch failed");
    //     } finally {
    //         setnifiBalanceLoading(false);
    //     }
    // };

    const fetchdillipayBalance = async () => {
        setdillipayBalanceLoading(true);

        try {
            const res = await checkdillipayBalance();
            // const res = await checkBalanceApi();

            if (res?.status === "Success") {
                setdillipayBalance(res.data.RunningBalance);
            }
        } catch (err) {
            console.error("Balance fetch failed");
        } finally {
            setdillipayBalanceLoading(false);
        }
    };
    const fetchearthypayBalance = async () => {
        setearthypayBalanceLoading(true);

        try {
            const res = await checkearthypayBalance();
            // const res = await checkBalanceApi();

            if (res?.status === "Success") {
                setearthypayBalance(res.dataContent.Balance);
            }
        } catch (err) {
            console.error("Balance fetch failed");
        } finally {
            setearthypayBalanceLoading(false);
        }
    };

    const fetchsrijipayBalance = async () => {
        setsrijipayBalanceLoading(true);

        try {
            const res = await checksrijipayBalance();

            if (res?.status === "Success") {
                setsrijipayBalance(res.data.RunningBalance);
            }

        } catch (err) {
            console.error("Srijipay Balance fetch failed");
        } finally {
            setsrijipayBalanceLoading(false);
        }
    };

    const fetchtramoBalance = async () => {
        settramoBalanceLoading(true);

        try {
            const res = await checktramoBalance();

            if (res?.status === "success") {
                settramoBalance(res.data.walletBalance.toFixed(0));
            }

        } catch (err) {
            console.error("Tramo Balance fetch failed");
        } finally {
            settramoBalanceLoading(false);
        }
    };

    // const fetchindicoreBalance = async () => {
    //     setindicoreBalanceLoading(true);

    //     try {
    //         const res = await checkindicoreBalance();
    //         // const res = await checkBalanceApi();

    //         if (res?.status === "Success") {
    //             setindicoreBalance(res.data.RunningBalance);
    //         }
    //     } catch (err) {
    //         console.error("Balance fetch failed");
    //     } finally {
    //         setindicoreBalanceLoading(false);
    //     }
    // };

    const fetchindicoreBalance = async () => {
        setindicoreBalanceLoading(true);

        try {
            const res = await checkindicoreBalance();

            console.log("Indicore Balance Response:", res);

            if (res?.status === true) {

                // "200|177976.7825"
                const responseParts = res?.response?.split("|");

                // second value = balance
                const balance = responseParts?.[1];

                setindicoreBalance(
                    Number(balance).toFixed(2)
                );
            }

        } catch (err) {
            console.error("Balance fetch failed", err);
        } finally {
            setindicoreBalanceLoading(false);
        }
    };

    const fetchinstantpayBalance = async () => {
        setinstantpayBalanceLoading(true);

        try {
            const res = await checkinstantpayBalance();
            // const res = await checkBalanceApi();

            if (res?.status === "Transaction Successful") {
                setinstantpayBalance(res.data.balance.available);
            }
        } catch (err) {
            console.error("Balance fetch failed");
        } finally {
            setinstantpayBalanceLoading(false);
        }
    };

    const fetchenkashBalance = async () => {
        setenkashBalanceLoading(true);

        try {
            const res = await checkenkashBalance();
            // const res = await checkBalanceApi();

            if (res?.status === "Success") {
                setenkashBalance(res.data.RunningBalance);
            }
        } catch (err) {
            console.error("Balance fetch failed");
        } finally {
            setenkashBalanceLoading(false);
        }
    };


    // const [balance, setBalance] = useState("");
    // const [balanceLoading, setBalanceLoading] = useState(false);
    // const { callApi: checkBalanceApi } = useApi(
    //     "/admin/users/aereon/check-balance",
    //     "POST"
    // );

    // const fetchBalance = async () => {
    //     setBalanceLoading(true);

    //     try {
    //         const res = await checkBalanceApi();

    //         if (res?.status === "SUCCESS") {
    //             setBalance(res.available_balance);
    //         }
    //     } catch (err) {
    //         console.error("Balance fetch failed");
    //     } finally {
    //         setBalanceLoading(false);
    //     }
    // };




    return (
        <>
            <div className="w-full">

                <h2 className="text-xl font-bold text-[#0A2A4F] mb-4">
                    CASH-IN PENDING REQUEST
                </h2>




                {/* WALLET BALANCE */}
                {/* HEADER */}
                {/* <div className="flex items-center justify-between px-3 md:px-4 mt-2"> */}
                <div className="flex items-center justify-between px-3 md:px-4 mt-2 gap-3">

                    <h2 className="text-lg md:text-xl font-bold text-[#0A2A4F]">
                        Provider Balances
                    </h2>

                    {/* <button
    onClick={() => setShowThresholdEditor(!showThresholdEditor)}
    className="px-3 py-1.5 rounded-lg bg-[#0A2A4F] text-white text-xs md:text-sm font-medium hover:opacity-90 transition"
  >
    {showThresholdEditor ? "Save Limits" : "Edit Limits"}
  </button> */}
                    <div className="flex items-center gap-2">

                        {/* REFRESH BALANCES BUTTON */}
                        {/* temporary hiding for test purposes */}
                        <button
                            onClick={refreshAllBalances}
                            className="px-3 py-1.5 rounded-lg bg-green-600 text-white text-xs md:text-sm font-medium hover:bg-green-700 transition flex items-center gap-2"
                        >
                            <FiRefreshCcw size={14} />
                            Refresh Balances
                        </button>

                        {/* EDIT LIMIT BUTTON */}
                        <button
                            onClick={() => setShowThresholdEditor(!showThresholdEditor)}
                            className="px-3 py-1.5 rounded-lg bg-[#0A2A4F] text-white text-xs md:text-sm font-medium hover:opacity-90 transition"
                        >
                            {showThresholdEditor ? "Save Limits" : "Edit Limits"}
                        </button>

                    </div>
                </div>

                {/* THRESHOLD EDITOR */}
                {showThresholdEditor && (
                    <div className="mx-3 md:mx-4 mt-3 bg-white rounded-xl shadow border p-4">

                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">

                            <div>
                                <p className="text-xs font-medium mb-1">Wallet</p>

                                <input
                                    type="number"
                                    value={thresholds.wallet}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            wallet: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                            <div>
                                <p className="text-xs font-medium mb-1">Aeron</p>
                                <input
                                    type="number"
                                    value={thresholds.aeron}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            aeron: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                            {/* <div>
                                <p className="text-xs font-medium mb-1">Nifi</p>
                                <input
                                    type="number"
                                    value={thresholds.nifi}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            nifi: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div> */}

                            <div>
                                <p className="text-xs font-medium mb-1">Dillipay</p>
                                <input
                                    type="number"
                                    value={thresholds.dillipay}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            dillipay: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                            <div>
                                <p className="text-xs font-medium mb-1">Earthpay</p>
                                <input
                                    type="number"
                                    value={thresholds.earthpay}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            earthpay: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                            <div>
                                <p className="text-xs font-medium mb-1">Indicore</p>
                                <input
                                    type="number"
                                    value={thresholds.indicore}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            indicore: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                            <div>
                                <p className="text-xs font-medium mb-1">Instantpay</p>
                                <input
                                    type="number"
                                    value={thresholds.instantpay}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            instantpay: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                            <div>
                                <p className="text-xs font-medium mb-1">Srijipay</p>

                                <input
                                    type="number"
                                    value={thresholds.srijipay}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            srijipay: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                            <div>
                                <p className="text-xs font-medium mb-1">Tramo</p>

                                <input
                                    type="number"
                                    value={thresholds.tramo}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            tramo: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                            <div>
                                <p className="text-xs font-medium mb-1">Finzep</p>
                                <input
                                    type="number"
                                    value={thresholds.finzep || ""}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            finzep: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                            <div>
                                <p className="text-xs font-medium mb-1">Finkeda</p>
                                <input
                                    type="number"
                                    value={thresholds.finkeda || ""}
                                    onChange={(e) =>
                                        setThresholds({
                                            ...thresholds,
                                            finkeda: e.target.value,
                                        })
                                    }
                                    placeholder="10000"
                                    className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
                                />
                            </div>

                             <div>
    <p className="text-xs font-medium mb-1">Soliteck</p>
    <input
        type="number"
        value={thresholds.soliteck || ""}
        onChange={(e) => setThresholds({ ...thresholds, soliteck: e.target.value })}
        placeholder="10000"
        className="w-full border rounded-lg px-2 py-2 text-sm outline-none"
    />
</div>       

                        </div>
                    </div>
                )}

                {/* BALANCE CARDS */}
                <div
                    className="
    flex md:flex-row flex-col
    md:flex-wrap
    gap-3
    p-3 md:p-4
  "
                >

                    {/* WALLET */}
                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(walletBalance, thresholds.wallet)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Wallet Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                ₹{walletBalance || "0.00"}
                            </p>

                            {thresholds.wallet && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.wallet}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchWalletBalance}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 transition flex-shrink-0"
                        >
                            <FiRefreshCcw size={14} />
                        </button>
                    </div>

                    {/* AERON */}
                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(balance, thresholds.aeron)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Aeron Pay Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {balanceLoading ? "..." : `₹${balance || "0.00"}`}
                            </p>

                            {thresholds.aeron && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.aeron}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchBalance}
                            disabled={balanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${balanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div>

                    {/* NIFI */}
                    {/* <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(nifiBalance, thresholds.nifi)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Nifi Pay Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {nifiBalanceLoading ? "..." : `₹${nifiBalance || "0.00"}`}
                            </p>

                            {thresholds.nifi && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.nifi}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchnifiBalance}
                            disabled={nifiBalanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${nifiBalanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div> */}

                    {/* DILLIPAY */}
                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(dillipayBalance, thresholds.dillipay)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Dillipay Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {dillipayBalanceLoading ? "..." : `₹${dillipayBalance || "0.00"}`}
                            </p>

                            {thresholds.dillipay && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.dillipay}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchdillipayBalance}
                            disabled={dillipayBalanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${dillipayBalanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div>

                    {/* EARTHPAY */}
                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(earthypayBalance, thresholds.earthpay)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Earthpay Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {earthypayBalanceLoading ? "..." : `₹${earthypayBalance || "0.00"}`}
                            </p>

                            {thresholds.earthpay && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.earthpay}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchearthypayBalance}
                            disabled={earthypayBalanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${earthypayBalanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div>

                    {/* INDICORE */}
                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(indicoreBalance, thresholds.indicore)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Indicore Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {indicoreBalanceLoading ? "..." : `₹${indicoreBalance || "0.00"}`}
                            </p>

                            {thresholds.indicore && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.indicore}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchindicoreBalance}
                            disabled={indicoreBalanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${indicoreBalanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div>

                    {/* INSTANTPAY */}
                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(instantpayBalance, thresholds.instantpay)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Instantpay Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {instantpayBalanceLoading ? "..." : `₹${instantpayBalance || "0.00"}`}
                            </p>

                            {thresholds.instantpay && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.instantpay}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchinstantpayBalance}
                            disabled={instantpayBalanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${instantpayBalanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div>
                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(srijipayBalance, thresholds.srijipay)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Srijipay Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {srijipayBalanceLoading ? "..." : `₹${srijipayBalance || "0.00"}`}
                            </p>

                            {thresholds.srijipay && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.srijipay}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchsrijipayBalance}
                            disabled={srijipayBalanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${srijipayBalanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div>

                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(tramoBalance, thresholds.tramo)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Tramo Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {tramoBalanceLoading ? "..." : `₹${tramoBalance || "0.00"}`}
                            </p>

                            {thresholds.tramo && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.tramo}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchtramoBalance}
                            disabled={tramoBalanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${tramoBalanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div>



                    {/* FINZEP */}
                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(finzepBalance, thresholds.finzep)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Finzep Balance
                            </p>

                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {finzepBalanceLoading ? "..." : `₹${finzepBalance || "0.00"}`}
                            </p>

                            {thresholds.finzep && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.finzep}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={fetchfinzepBalance}
                            disabled={finzepBalanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${finzepBalanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div>

                    {/* FINKEDA */}
                    <div
                        className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(finkedaBalance, thresholds.finkeda)
                            ? "bg-gradient-to-r from-red-600 to-red-700"
                            : "bg-gradient-to-r from-green-600 to-green-700"
                            }`}
                    >
                        <div className="text-left min-w-0">
                            <p className="text-[10px] md:text-xs opacity-80">
                                Finkeda Balance
                            </p>
                            <p className="text-sm md:text-lg font-bold tracking-wide truncate">
                                {finkedaBalanceLoading ? "..." : `₹${finkedaBalance || "0.00"}`}
                            </p>
                            {thresholds.finkeda && (
                                <p className="text-[10px] opacity-80 mt-1">
                                    Limit: ₹{thresholds.finkeda}
                                </p>
                            )}
                        </div>
                        <button
                            onClick={fetchFinkedaBalance}
                            disabled={finkedaBalanceLoading}
                            className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
                        >
                            <FiRefreshCcw
                                size={14}
                                className={`${finkedaBalanceLoading ? "animate-spin" : ""}`}
                            />
                        </button>
                    </div>

                    <div
    className={`rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white transition-all ${isBelowThreshold(soliteckBalance, thresholds.soliteck)
        ? "bg-gradient-to-r from-red-600 to-red-700"
        : "bg-gradient-to-r from-green-600 to-green-700"
        }`}
>
    <div className="text-left min-w-0">
        <p className="text-[10px] md:text-xs opacity-80">Soliteck Balance</p>
        <p className="text-sm md:text-lg font-bold tracking-wide truncate">
            {soliteckBalanceLoading ? "..." : `₹${soliteckBalance || "0.00"}`}
        </p>
        {thresholds.soliteck && (
            <p className="text-[10px] opacity-80 mt-1">Limit: ₹{thresholds.soliteck}</p>
        )}
    </div>
    <button
        onClick={fetchSoliteckBalance}
        disabled={soliteckBalanceLoading}
        className="p-1.5 md:p-2 bg-white text-green-700 rounded-full hover:bg-gray-100 disabled:opacity-50 transition flex-shrink-0"
    >
        <FiRefreshCcw size={14} className={`${soliteckBalanceLoading ? "animate-spin" : ""}`} />
    </button>
</div>




{/* ========================================================= */}
          {/*                 COMING SOON CHANNELS                      */}
          {/* ========================================================= */}

          {[
              { name: "Enkash Balance" },
            
              { name: "Bill Avenue Balance" },
              { name: "Chagans Balance" },
              { name: "Urbanrupee Balance" },
              { name: "Quick KYC Balance" },
              { name: "Fingpay Balance" }
          ].map((item, index) => (
              <div
                  key={index}
                  className="rounded-xl px-3 py-2 md:px-5 md:py-3 shadow flex items-center justify-between md:gap-5 w-full md:w-auto md:min-w-[240px] text-white/90 bg-gradient-to-r from-slate-500 to-slate-600 opacity-75 select-none transition-all duration-200"
              >
                  <div className="text-left min-w-0">
                      <p className="text-[10px] md:text-xs opacity-75">
                          {item.name}
                      </p>
                      <p className="text-xs md:text-sm font-semibold tracking-wide mt-1 bg-white/20 px-2 py-0.5 rounded-md inline-block">
                          Coming Soon
                      </p>
                  </div>
                  <div className="p-1.5 md:p-2 bg-white/10 text-white/50 rounded-full cursor-not-allowed flex-shrink-0">
                      <FiRefreshCcw size={14} className="opacity-40" />
                  </div>
              </div>
          ))}



                </div>

                {/* ----------- BANK FILTER BUTTONS ----------- */}

                <div className="flex gap-3 mb-4 items-center justify-center flex-wrap">
                    {/* REFRESH TABLE BUTTON */}

                    <div className="flex justify-center  ">
                        <button
                            // onClick={fetchRequests}
                            onClick={async () => {
                                await fetchRequests();
                                await fetchBankCounts();
                                // await refreshAllBalances()
                            }}
                            disabled={loading}
                            className="relative px-6 py-3 rounded-full font-semibold border bg-white text-[#0A2A4F] border-[#0A2A4F] hover:bg-[#0A2A4F] hover:text-white transition flex items-center gap-2"
                        >
                            <FiRefreshCcw
                                size={16}
                                className={loading ? "animate-spin" : ""}
                            />

                            {/* {loading ? "Refreshing..." : "Refresh Table"} */}
                        </button>
                    </div>

                    {/* ALL BUTTON */}

                    <button
                        onClick={() => setSelectedBank("")}
                        className={`relative px-5 py-2 rounded-full font-semibold border transition
        ${selectedBank === ""
                                ? "bg-[#0A2A4F] text-white"
                                : "bg-white text-[#0A2A4F] border-[#0A2A4F] hover:bg-[#0A2A4F] hover:text-white"
                            }`}
                    >
                        ALL
                    </button>

                    {/* BANK BUTTONS */}

                    {bankCount?.map((bank) => (

                        <button
                            key={bank.bankName}
                            onClick={() => setSelectedBank(bank.bankName)}
                            className={`relative px-5 py-2 rounded-full font-semibold border transition
            ${selectedBank === bank.bankName
                                    ? "bg-[#0A2A4F] text-white"
                                    : "bg-white text-[#0A2A4F] border-[#0A2A4F] hover:bg-[#0A2A4F] hover:text-white"
                                }`}
                        >
                            {bank.nickName}

                            {bank.pendingCount > 0 && (
                                <span className="absolute -top-2 -right-2 bg-red-600 text-white text-lg font-bold rounded-full px-2 py-[3px] min-w-[24px] flex items-center justify-center">
                                    {bank.pendingCount}
                                </span>
                            )}

                        </button>

                    ))}

                </div>

                {/* Desktop */}

                <div className="hidden md:block rounded-xl border border-gray-300 bg-white shadow-sm max-h-[70vh] overflow-auto">

                    <table className="w-full text-sm border-collapse">

                        <thead className="bg-[#0A2A4F] text-white sticky top-0">

                            <tr>
                                <th className="border px-3 py-2">User Details</th>
                                <th className="border px-3 py-2">Request Amount</th>
                                <th className="border px-3 py-2">Request Time</th>
                                <th className="border px-3 py-2">Deposit Date</th>
                                <th className="border px-3 py-2">Mode</th>
                                <th className="border px-3 py-2">Bank</th>
                                <th className="border px-3 py-2">Txn Ref</th>
                                <th className="border px-3 py-2">Admin Re-enter Amount</th>
                                <th className="border px-3 py-2">Admin Remarks</th>
                                <th className="border px-3 py-2">Proof</th>
                                <th className="border px-3 py-2">Action</th>
                            </tr>

                        </thead>

                        <tbody>
                            {loading ? (

                                <tr>
                                    <td colSpan="10" className="text-center py-6">
                                        Loading...
                                    </td>
                                </tr>

                            ) : data.length > 0 ? (

                                data.map((row, index) => (

                                    <tr key={index} className="hover:bg-gray-50">

                                        <td className="border px-3 py-2">

                                            <div className="font-semibold">{row.shopName}</div>
                                            <div>{row.name}</div>
                                            <div className="text-xs text-gray-500">{row.mobile}</div>
                                            <div className="text-xs text-gray-500">
                                                {row.role || "-"} | {row.district || "-"}
                                            </div>

                                        </td>

                                        <td className={`border px-3 py-2 ${getAmountColor(row.amount)}`}>

                                            <div className="font-semibold">
                                                ₹{row.amount?.toLocaleString()}
                                            </div>

                                            <div className="text-xs font-bold">
                                                {numberToWords(Math.floor(row.amount || 0))}
                                            </div>

                                        </td>

                                        <td className="border px-3 py-2">
                                            {formatDateTime(row.requestTime)}
                                        </td>

                                        <td className="border px-3 py-2">
                                            {row.depositDate}
                                        </td>

                                        <td className={`border px-3 py-2 ${getModeColor(row.paymentMode)}`}>
                                            {row.paymentMode}
                                        </td>
                                        <td className="border px-3 py-2">
                                            {row.bankName || "-"}
                                        </td>

                                        <td className="border px-3 py-2">
                                            {row.requesterRemarks}
                                        </td>

                                        <td className={`border px-3 py-2 ${getAmountColor(amountInput[index])}`}>

                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                className="border px-2 py-1 rounded w-full"
                                                value={amountInput[index] || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    // Allow ONLY digits (0-9)
                                                    if (/^\d*$/.test(value)) {
                                                        setAmountInput({
                                                            ...amountInput,
                                                            [index]: value
                                                        });
                                                    }
                                                }}
                                            />

                                            <div className="text-xs font-bold mt-1">
                                                {numberToWords(Math.floor(amountInput[index] || 0))}
                                            </div>

                                        </td>

                                        <td className="border px-3 py-2">

                                            <input
                                                type="text"
                                                placeholder="Admin remarks"
                                                className="border px-2 py-1 rounded w-full"
                                                value={remarks[index] || ""}
                                                onChange={(e) =>
                                                    setRemarks({
                                                        ...remarks,
                                                        [index]: e.target.value
                                                    })
                                                }
                                            />

                                        </td>

                                        <td className="border px-3 py-2">
                                            <div className="flex justify-center">
                                                <button
                                                    onClick={() =>
                                                        setProofPopup({
                                                            open: true,
                                                            url: row.proofUrl
                                                        })
                                                    }
                                                    className="text-blue-600 underline"
                                                >
                                                    View
                                                </button>
                                            </div>
                                        </td>

                                        <td className="border px-3 py-2">

                                            <div className="flex gap-2 min-w-[140px]">

                                                <button
                                                    onClick={() =>
                                                        setConfirmPopup({
                                                            open: true,
                                                            type: "approve",
                                                            row,
                                                            index
                                                        })
                                                    }
                                                    className="bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1.5 rounded font-semibold"
                                                >
                                                    Approve
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        setConfirmPopup({
                                                            open: true,
                                                            type: "reject",
                                                            row,
                                                            index
                                                        })
                                                    }
                                                    className="bg-red-600 hover:bg-red-700 text-white text-xs px-3 py-1.5 rounded font-semibold"
                                                >
                                                    Reject
                                                </button>

                                            </div>

                                        </td>



                                    </tr>

                                ))

                            ) : (

                                <tr>
                                    <td colSpan="10" className="text-center py-6">
                                        No Pending Requests
                                    </td>
                                </tr>

                            )}

                        </tbody>

                    </table>

                </div>

                {/* ---------------- MOBILE CARD VIEW ---------------- */}

                <div className="md:hidden space-y-4 pb-24">

                    {loading ? (

                        <div className="text-center py-6">Loading...</div>

                    ) : data.length > 0 ? (

                        data.map((row, index) => (

                            <div
                                key={index}
                                className="bg-white border border-gray-300 rounded-xl shadow-sm p-4"
                            >

                                {/* USER */}

                                <div className="mb-3">
                                    <div className="font-bold text-[#0A2A4F] text-base">{row.shopName}</div>
                                    <div className="text-sm">{row.name}</div>
                                    <div className="text-xs text-gray-500">{row.mobile}</div>
                                    <div className="text-xs text-gray-500">{row.role || "-"} | {row.district || "-"}</div>
                                </div>

                                {/* AMOUNT */}

                                <div className={`text-lg font-bold ${getAmountColor(row.amount)}`}>
                                    ₹{row.amount?.toLocaleString()}
                                </div>

                                <div className="text-xs font-semibold mb-3">
                                    {numberToWords(Math.floor(row.amount || 0))}
                                </div>

                                {/* DETAILS */}

                                <div className="grid grid-cols-2 gap-3 text-sm mb-3">

                                    <div>
                                        <div className="text-xs text-gray-500">Request Time</div>
                                        {formatDateTime(row.requestTime)}
                                    </div>

                                    <div>
                                        <div className="text-xs text-gray-500">Deposit Date</div>
                                        {row.depositDate}
                                    </div>

                                    <div>
                                        <div className="text-xs text-gray-500">Mode</div>
                                        <span className={getModeColor(row.paymentMode)}>
                                            {row.paymentMode}
                                        </span>
                                    </div>

                                    <div>
                                        <div className="text-xs text-gray-500">Bank</div>
                                        {row.bankName || "-"}
                                    </div>

                                </div>

                                {/* TXN REF */}

                                <div className="mb-3">
                                    <div className="text-xs text-gray-500">Txn Ref</div>
                                    <div className="text-sm">{row.requesterRemarks}</div>
                                </div>

                                {/* ADMIN AMOUNT */}

                                <div className="mb-3">

                                    <div className="text-xs text-gray-500 mb-1">
                                        Admin Re-enter Amount
                                    </div>

                                    <input
                                        type="number"
                                        className="border px-2 py-2 rounded w-full"
                                        value={amountInput[index] || ""}
                                        onChange={(e) =>
                                            setAmountInput({
                                                ...amountInput,
                                                [index]: e.target.value
                                            })
                                        }
                                    />

                                    <div className="text-xs font-semibold mt-1">
                                        {numberToWords(Math.floor(amountInput[index] || 0))}
                                    </div>

                                </div>

                                {/* REMARKS */}

                                <div className="mb-3">

                                    <div className="text-xs text-gray-500 mb-1">
                                        Admin Remarks
                                    </div>

                                    <input
                                        type="text"
                                        placeholder="Admin remarks"
                                        className="border px-2 py-2 rounded w-full"
                                        value={remarks[index] || ""}
                                        onChange={(e) =>
                                            setRemarks({
                                                ...remarks,
                                                [index]: e.target.value
                                            })
                                        }
                                    />

                                </div>

                                {/* PROOF */}

                                <button
                                    onClick={() =>
                                        setProofPopup({
                                            open: true,
                                            url: row.proofUrl
                                        })
                                    }
                                    className="text-blue-600 underline text-sm mb-3"
                                >
                                    View Proof
                                </button>

                                {/* ACTION */}

                                <div className="flex gap-2">

                                    <button
                                        onClick={() =>
                                            setConfirmPopup({
                                                open: true,
                                                type: "approve",
                                                row,
                                                index
                                            })
                                        }
                                        className="flex-1 bg-green-600 text-white py-2 rounded text-sm font-semibold"
                                    >
                                        Approve
                                    </button>

                                    <button
                                        onClick={() =>
                                            setConfirmPopup({
                                                open: true,
                                                type: "reject",
                                                row,
                                                index
                                            })
                                        }
                                        className="flex-1 bg-red-600 text-white py-2 rounded text-sm font-semibold"
                                    >
                                        Reject
                                    </button>

                                </div>

                            </div>

                        ))

                    ) : (

                        <div className="text-center py-6">
                            No Pending Requests
                        </div>

                    )}

                </div>

                {/* POPUP */}

                {confirmPopup.open && (

                    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

                        {/* <div className="bg-white rounded-lg shadow-lg p-6 w-[340px]"> */}

                        <div className="bg-white rounded-2xl shadow-2xl p-7 w-[500px] max-w-[95vw] border border-gray-200">

                            {!message.text && !loadingAction && (
                                <>
                                    <h3 className="text-xl font-bold text-[#0A2A4F] mb-2">
                                        {confirmPopup.type === "approve"
                                            ? "Approve Cash-In Request"
                                            : "Reject Cash-In Request"}
                                    </h3>

                                    <p className="text-sm text-gray-500 mb-5">
                                        {confirmPopup.type === "approve"
                                            ? "Please review the details before approving this request."
                                            : "This action cannot be undone."}
                                    </p>

                                    {confirmPopup.type === "approve" && (
                                        <div className="mb-5 rounded-2xl border border-green-200 bg-gradient-to-r from-green-50 to-emerald-50 p-5">

                                            <div className="flex items-center justify-between">

                                                <div>
                                                    <h4 className="font-semibold text-gray-800">
                                                        Apply TP Fee
                                                    </h4>

                                                    <p className="text-sm text-gray-500 mt-1">
                                                        Enable TP fee deduction while approving.
                                                    </p>
                                                </div>

                                                <button
                                                    type="button"
                                                    onClick={() => setTpEnabled(!tpEnabled)}
                                                    className={`relative inline-flex h-8 w-14 items-center rounded-full transition-all duration-300 ${tpEnabled
                                                            ? "bg-green-600"
                                                            : "bg-gray-300"
                                                        }`}
                                                >
                                                    <span
                                                        className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition-all duration-300 ${tpEnabled
                                                                ? "translate-x-7"
                                                                : "translate-x-1"
                                                            }`}
                                                    />
                                                </button>

                                            </div>

                                            <div className="mt-4">
                                                <span
                                                    className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${tpEnabled
                                                            ? "bg-green-100 text-green-700"
                                                            : "bg-gray-100 text-gray-600"
                                                        }`}
                                                >
                                                    {tpEnabled
                                                        ? "✓ TP Fee Enabled"
                                                        : "Normal Approval Flow"}
                                                </span>
                                            </div>

                                        </div>
                                    )}

                                    {confirmPopup.type === "approve" && (
                                        <div className="mb-5">
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                                MPIN <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="password"
                                                maxLength={6}
                                                value={mpin}
                                                onChange={e => setMpin(e.target.value.replace(/\D/g, ""))}
                                                placeholder="Enter MPIN"
                                                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-gray-800 font-semibold tracking-widest text-center text-lg"
                                            />
                                        </div>
                                    )}

                                    <div className="flex justify-end gap-3 mt-6">

                                        <button
                                            onClick={() => {
                                                setTpEnabled(false);
                                                setMpin("");

                                                setConfirmPopup({
                                                    open: false,
                                                    type: "",
                                                    row: null,
                                                    index: null
                                                });
                                            }}
                                            className="px-5 py-2.5 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium"
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            onClick={handleConfirm}
                                            className={`px-5 py-2.5 rounded-xl text-white font-semibold ${confirmPopup.type === "approve"
                                                    ? "bg-green-600 hover:bg-green-700"
                                                    : "bg-red-600 hover:bg-red-700"
                                                }`}
                                        >
                                            {confirmPopup.type === "approve"
                                                ? "Approve Request"
                                                : "Reject Request"}
                                        </button>

                                    </div>
                                </>
                            )}

                            {loadingAction && (
                                <div className="flex flex-col items-center py-8">

                                    <div className="w-12 h-12 border-[5px] border-green-500 border-t-transparent rounded-full animate-spin"></div>

                                    <p className="mt-4 text-sm font-medium text-gray-600">
                                        Processing Request...
                                    </p>

                                </div>
                            )}

                            {message.text && !loadingAction && (
                                <div
                                    className={`text-center py-6 text-base font-semibold ${message.type === "success"
                                            ? "text-green-600"
                                            : "text-red-600"
                                        }`}
                                >
                                    {message.text}
                                </div>
                            )}

                        </div>
                        {/*                             
                            {!message.text && !loadingAction && (

                                <h3 className="text-lg font-semibold mb-3 text-gray-800">

                                    {confirmPopup.type === "approve"
                                        ? "Are you sure you want to approve this transfer?"
                                        : "Are you sure you want to reject this request?"}

                                </h3>

                            )}

                            

                            {loadingAction && (

                                <div className="flex flex-col items-center py-4">

                                    <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>

                                    <p className="mt-3 text-sm text-gray-600">
                                        Processing request...
                                    </p>

                                </div>

                            )}

                            {message.text && !loadingAction && (

                                <div className={`text-center text-sm font-semibold py-3
                            ${message.type === "success" ? "text-green-600" : "text-red-600"}`}>

                                    {message.text}

                                </div>

                            )}

                            {!loadingAction && !message.text && (

                                <div className="flex justify-end gap-3 mt-4">

                                    <button
                                        onClick={() =>
                                            setConfirmPopup({
                                                open: false,
                                                type: "",
                                                row: null,
                                                index: null
                                            })
                                        }
                                        className="px-3 py-1.5 text-sm bg-gray-300 rounded"
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        onClick={handleConfirm}
                                        className={`px-3 py-1.5 text-sm text-white rounded
                                    ${confirmPopup.type === "approve"
                                                ? "bg-green-600 hover:bg-green-700"
                                                : "bg-red-600 hover:bg-red-700"}`}
                                    >
                                        OK
                                    </button>

                                </div>

                            )} */}


                        {/* </div> */}

                    </div>

                )}

                {/* OTP POPUP */}

                {otpPopup.open && (
                    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-2xl shadow-2xl w-[460px] max-w-[95vw] border border-gray-200 overflow-hidden">

                            {/* Header */}
                            <div className="bg-[#0A2A4F] px-6 py-4 flex items-center justify-between">
                                <h3 className="text-[17px] font-bold text-white tracking-wide">OTP Verification</h3>
                                <button
                                    onClick={() => { setOtpPopup({ open: false, pendingPayload: null, sentTo: [] }); setOtpInput(""); setOtpError(""); setConfirmPopup({ open: false, type: "", row: null, index: null }); }}
                                    disabled={otpLoading}
                                    className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-lg leading-none disabled:opacity-40"
                                >×</button>
                            </div>

                            {/* Body */}
                            <div className="px-6 py-5">

                                <p className="text-sm text-gray-600 mb-3">
                                    OTP has been sent to the registered approver. Enter the 6-digit OTP to continue.
                                </p>

                                {otpPopup.sentTo?.length > 0 && (
                                    <div className="flex flex-wrap gap-2 mb-4">
                                        <span className="text-xs text-gray-400 font-medium self-center">OTP sent to:</span>
                                        {otpPopup.sentTo.map((num, i) => (
                                            <span key={i} className="px-3 py-1 rounded-full bg-[#EFF6FF] border border-[#BFDBFE] text-[#0A2A4F] text-sm font-semibold">
                                                {num}
                                            </span>
                                        ))}
                                    </div>
                                )}

                                {/* 6-digit OTP input */}
                                <div className="mb-1">
                                    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                                        Enter 6-digit OTP
                                    </label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={6}
                                        value={otpInput}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, "").slice(0, 6);
                                            setOtpInput(val);
                                            setOtpError("");
                                        }}
                                        onKeyDown={(e) => e.key === "Enter" && handleOtpSubmit()}
                                        placeholder="_ _ _ _ _ _"
                                        className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 text-2xl tracking-[0.6em] text-center font-bold text-[#0A2A4F] outline-none focus:border-[#0A2A4F] transition placeholder:text-gray-300 placeholder:tracking-[0.6em]"
                                        disabled={otpLoading}
                                        autoFocus
                                    />
                                    {/* digit counter */}
                                    <p className={`text-xs mt-1 text-right font-medium ${otpInput.length === 6 ? "text-green-600" : "text-gray-400"}`}>
                                        {otpInput.length} / 6
                                    </p>
                                </div>

                                {otpError && (
                                    <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg px-3 py-2 mt-2 mb-1">
                                        <span className="text-red-500 text-base leading-none">⚠</span>
                                        <p className="text-sm text-red-600 font-medium">{otpError}</p>
                                    </div>
                                )}
                            </div>

                            {/* Footer buttons */}
                            <div className="px-6 pb-5 flex gap-3">
                                {/* Reject — closes OTP popup and re-opens confirm as reject */}
                                <button
                                    onClick={() => {
                                        setOtpPopup({ open: false, pendingPayload: null, sentTo: [] });
                                        setOtpInput("");
                                        setOtpError("");
                                        setConfirmPopup(prev => ({ ...prev, open: true, type: "reject" }));
                                    }}
                                    disabled={otpLoading}
                                    className="flex-1 px-4 py-2.5 rounded-xl bg-red-50 hover:bg-red-100 border border-red-200 text-red-600 font-semibold text-sm disabled:opacity-50 transition"
                                >
                                    Reject
                                </button>

                                {/* Approve with OTP */}
                                <button
                                    onClick={handleOtpSubmit}
                                    disabled={otpLoading || otpInput.length !== 6}
                                    className="flex-1 px-4 py-2.5 rounded-xl bg-green-600 hover:bg-green-700 text-white font-semibold text-sm disabled:opacity-50 flex items-center justify-center gap-2 transition"
                                >
                                    {otpLoading ? (
                                        <>
                                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                            Verifying…
                                        </>
                                    ) : (
                                        <>✓ Approve</>
                                    )}
                                </button>
                            </div>

                        </div>
                    </div>
                )}

                {/* PROOF POPUP */}

                {proofPopup.open && (
                    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">

                        <div className="relative bg-white rounded-lg shadow-xl w-[90vw] h-[90vh] flex flex-col">

                            <TransformWrapper>
                                {({ zoomIn, zoomOut, resetTransform }) => (
                                    <>
                                        {/* HEADER */}
                                        <div className="flex justify-between items-center border-b px-4 py-3">

                                            <h3 className="font-semibold text-gray-800 text-lg">
                                                Payment Proof
                                            </h3>

                                            {/* 👉 ALL BUTTONS HERE */}
                                            <div className="flex items-center gap-2">

                                                {/* Rotate */}
                                                <button
                                                    onClick={() => setRotation((prev) => prev - 90)}
                                                    className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded text-sm"
                                                >
                                                    ⟲
                                                </button>

                                                <button
                                                    onClick={() => setRotation((prev) => prev + 90)}
                                                    className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded text-sm"
                                                >
                                                    ⟳
                                                </button>

                                                {/* Zoom */}
                                                <button
                                                    onClick={() => zoomIn()}
                                                    className="px-2 py-1 bg-indigo-600 hover:bg-indigo-700 text-white rounded text-sm"
                                                >
                                                    +
                                                </button>

                                                <button
                                                    onClick={() => zoomOut()}
                                                    className="px-2 py-1 bg-indigo-600 hover:bg-indigo-700 text-white rounded text-sm"
                                                >
                                                    -
                                                </button>

                                                {/* Reset */}
                                                <button
                                                    onClick={() => {
                                                        resetTransform();
                                                        setRotation(0);
                                                    }}
                                                    className="px-2 py-1 bg-amber-500 hover:bg-amber-600 text-white rounded text-sm"
                                                >
                                                    Reset
                                                </button>

                                                {/* Close */}
                                                <button
                                                    onClick={() =>
                                                        setProofPopup({
                                                            open: false,
                                                            url: ""
                                                        })
                                                    }
                                                    className="px-3 py-1 bg-red-600 hover:bg-red-700 text-white rounded text-sm"
                                                >
                                                    Close
                                                </button>

                                            </div>
                                        </div>

                                        {/* IMAGE AREA */}
                                        <div className="flex-1 flex items-center justify-center overflow-hidden p-4">

                                            <TransformComponent>
                                                <div
                                                    style={{
                                                        transform: `rotate(${rotation}deg)`
                                                    }}
                                                >
                                                    <img
                                                        src={proofPopup.url}
                                                        alt="proof"
                                                        className="max-h-[70vh] max-w-full object-contain rounded"
                                                    />
                                                </div>
                                            </TransformComponent>

                                        </div>
                                    </>
                                )}
                            </TransformWrapper>

                        </div>
                    </div>
                )}

            </div>

            <MerchantTopupTable />
            {/* <MerchantTopupTable triggerBalanceRefresh={() => {
                fetchWalletBalance();
                refreshAllBalances();
            }} /> */}
        </>
    );
};

export default MerchantTopupPendingTable;